export enum EnumStatusSituacaoPedido {
    ABERTO = 1,
    BLOQUEADO = 2,
    IMPORTADO = 3,
    CANCELADO = 4,
    FECHAMENTO_PARCIAL = 6
}